/**
 * Camp Essentials — Gear, Recipes, Fireside hub (V2 shell).
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTools, FaUtensils, FaChevronRight, FaShoppingBag } from 'react-icons/fa';
import { GiCampfire } from 'react-icons/gi';
import './camp-essentials-shell.css';

const CAMP_CARDS = [
  {
    id: 'gear',
    title: 'Gear',
    description: 'Find RVs, trailers, ATVs, grills, and hunt gear near you — or browse member listings.',
    icon: FaTools,
    actionLabel: 'Find gear',
    disabled: false,
    path: '/camp-essentials/gear',
  },
  {
    id: 'recipes',
    title: 'Recipes',
    description: 'Big-batch and grill-friendly recipes for camp nights — and where to get food near camp.',
    icon: FaUtensils,
    actionLabel: 'Open recipes',
    disabled: false,
    path: '/camp-essentials/recipes',
  },
  {
    id: 'fireside',
    title: 'Fireside',
    description: 'Playlists, podcasts, stories, and words of this land.',
    icon: GiCampfire,
    actionLabel: 'Coming soon',
    disabled: true,
    path: null,
  },
];

export function CampEssentialsPage() {
  const navigate = useNavigate();

  return (
    <div
      className="camp-essentials-shell"
      data-testid="camp-essentials-page"
    >
      <svg className="camp-essentials-shell__bg-grid" aria-hidden="true">
        <defs>
          <pattern
            id="camp-essentials-grid"
            width="40"
            height="40"
            patternUnits="userSpaceOnUse"
          >
            <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#camp-essentials-grid)" />
      </svg>

      <div className="camp-essentials-shell__inner">
        <header className="camp-essentials-shell__header">
          <div className="camp-essentials-shell__section-row">
            <span className="camp-essentials-shell__section-label">Community</span>
            <span className="camp-essentials-shell__section-rule" />
          </div>
          <div className="camp-essentials-shell__header-main">
            <div
              className="camp-essentials-shell__header-icon"
              aria-hidden="true"
            >
              <FaShoppingBag size={18} />
            </div>
            <div>
              <h1 className="camp-essentials-shell__title" data-testid="page-hero">
                Camp Essentials
              </h1>
              <p className="camp-essentials-shell__subtitle">Gear, recipes &amp; fireside</p>
            </div>
          </div>
          <p className="camp-essentials-shell__lede">
            Everything your crew needs off the stand — gear near camp, recipes for the grill, and
            fireside when the day is done.
          </p>
        </header>

        <div
          className="camp-essentials-shell__grid"
          aria-label="Camp essentials sections"
        >
          {CAMP_CARDS.map((card) => {
            const Icon = card.icon;
            return (
              <button
                key={card.id}
                type="button"
                className="camp-essentials-shell__card"
                data-testid={`camp-essentials-card-${card.id}`}
                disabled={card.disabled}
                onClick={() => card.path && navigate(card.path)}
              >
                <div className="camp-essentials-shell__card-top">
                  <div className="camp-essentials-shell__card-icon" aria-hidden="true">
                    <Icon size={20} />
                  </div>
                  {!card.disabled ? (
                    <FaChevronRight
                      className="camp-essentials-shell__card-chevron"
                      size={14}
                      aria-hidden="true"
                    />
                  ) : (
                    <span className="camp-essentials-shell__badge">Soon</span>
                  )}
                </div>
                <div className="camp-essentials-shell__card-body">
                  <h2 className="camp-essentials-shell__card-title">{card.title}</h2>
                  <p className="camp-essentials-shell__card-desc">{card.description}</p>
                </div>
                <div className="camp-essentials-shell__card-footer">
                  <span className="camp-essentials-shell__card-action">{card.actionLabel}</span>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
